const platform = process.env.REACT_APP_PLATFORM
const environment = process.env.REACT_APP_BUILD_ENV

let endpoint
if (environment === 'local') {
  endpoint = process.env.REACT_APP_SERVER_ENDPOINT_LOCAL
} else if (environment === 'development') {
  endpoint = process.env.REACT_APP_SERVER_ENDPOINT_DEV
} else if (environment === 'uat') {
  endpoint = process.env.REACT_APP_SERVER_ENDPOINT_UAT
} else if (environment === 'production') {
  endpoint = process.env.REACT_APP_SERVER_ENDPOINT_PROD
}

let path
let platformHeader
if (platform === 'vp') {
  path = 'vitauser'
  platformHeader = 'Vita Passport'
} else if (platform === 'enterprise') {
  path = 'vitaenterprise'
  platformHeader = 'Vita Enterprise'
} else if (platform === 'vt') {
  path = 'vitateam'
  platformHeader = 'Vita Teams'
} else if (platform === 'teams') {
  path = 'vitalchemy'
  platformHeader = 'Vita Teams Assessment'
}

const env = {
  platform,
  environment,
  endpoint,
  path,
  platformHeader
}

export default env;
